import { z } from "zod";
import {
  REBOQUE_REQUIRED_FIELDS,
  hasValue,
  isReboqueComplete,
  isReboqueStarted,
} from "./constants";
import { getReboqueFieldRequiredMessage } from "./messages";

const optionalString = z.string().optional().nullable();

export const reboqueFormSchema = z
  .object({
    id: optionalString,
    placaReboque: optionalString,
    renavamReboque: optionalString,
    ufReboque: optionalString,
    descricaoReboque: optionalString,
    rntrcReboque: optionalString,
    tipoRNTRCReboque: optionalString,
    TipoCarroceriaReboque: optionalString,
    anttReboque: optionalString,
    cnhReboque: optionalString,
    capacidadeKGReboque: optionalString,
    capacidadeM3Reboque: optionalString,
    pesoTaraReboque: optionalString,
    tipoProprietarioReboque: optionalString,
    cpfoucnpjReboque: optionalString,
    nomeProprietarioReboque: optionalString,
  })
  .passthrough()
  .superRefine((reboque, ctx) => {
    if (!isReboqueStarted(reboque) && !isReboqueComplete(reboque)) {
      // Cadastro novo: todos os obrigatórios
      REBOQUE_REQUIRED_FIELDS.forEach((field) => {
        if (!hasValue(reboque[field.key])) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [field.key],
            message: getReboqueFieldRequiredMessage(0, field.key),
          });
        }
      });
      return;
    }

    REBOQUE_REQUIRED_FIELDS.forEach((field) => {
      if (!hasValue(reboque[field.key])) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [field.key],
          message: getReboqueFieldRequiredMessage(0, field.key),
        });
      }
    });
  });
